import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AuthCallback } from "./components/AuthCallback";
import Login from "./pages/Login";
import { Toaster } from "sonner";
import { AudioPlayer } from "./components/AudioPlayer";
import { MobileNav, Sidebar } from "./components/Sidebar";
import { PlayerProvider } from "./context/PlayerContext";
import Create from "./pages/Create";
import Discover from "./pages/Discover";
import Library from "./pages/Library";
import SongPage from "./pages/SongPage";
import Playlists from "./pages/Playlists";
import PlaylistPage from "./pages/PlaylistPage";
import Profile from "./pages/Profile";
import Creator from "./pages/Creator";
import Following from "./pages/Following";

const Loading = () => (
  <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center">
    <Loader2 className="w-8 h-8 animate-spin text-[var(--c-orange)]" />
  </div>
);

const PublicRoutes = () => (
  <Routes>
    <Route path="/prisijungti" element={<Login />} />
    <Route path="*" element={<Navigate to="/prisijungti" replace />} />
  </Routes>
);

const AppLayout = () => (
  <PlayerProvider>
    <div className="flex min-h-screen">
      <Sidebar />
      <MobileNav />
      <main className="flex-1 min-w-0 px-5 sm:px-8 lg:px-12 pt-20 md:pt-12 pb-36">
        <Routes>
          <Route path="/" element={<Create />} />
          <Route path="/atrasti" element={<Discover />} />
          <Route path="/biblioteka" element={<Library />} />
          <Route path="/daina/:id" element={<SongPage />} />
          <Route path="/grojarasciai" element={<Playlists />} />
          <Route path="/grojarastis/:id" element={<PlaylistPage />} />
          <Route path="/profilis" element={<Profile />} />
          <Route path="/autorius/:id" element={<Creator />} />
          <Route path="/sekami" element={<Following />} />
          <Route path="/prisijungti" element={<Navigate to="/" replace />} />
              </Routes>
      </main>
    </div>
    <AudioPlayer />
  </PlayerProvider>
);

function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (user === null) return <Loading />;
  return user ? <AppLayout /> : <PublicRoutes />;
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
